import { getUserExperimentIdentifier } from '../../experiments/getUserExperimentIdentifier';
import { getAllUtkExperiments } from '../../experiments/getUtkExperiments';
export const getBulkTreatmentsRequestData = () => {
  const experiments = getAllUtkExperiments();
  return experiments.map(key => ({
    key,
    identifier: getUserExperimentIdentifier(),
    maxAge: 0
  }));
};